import React from 'react'

export default function UpcomingEvents() {
  return (
    <div>
       <div class="service_area pb-70">
      
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-6 col-sm-12 event d-flex justify-content-center mb-3 mb-md-0">
            <div class="service_style_two mb-4">
              <div class="service_style_two_number mr-60 w-30">
              <img src='assets/images/Gartner.webp' className="img-fluid" alt="Gartner Marketing Xpo"/>
              </div>
           
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="service_style_two mb-4">
           
              <div class="service_style_two_content">
                <div class="service_style_two_title pb-3">
                  <h4>Gartner Marketing Symposium | Xpo 2025.</h4>
                </div>
                <div class="service_style_two_text">
                  <p className='text-left ml-75'>
                  Meet us at booth #116 <br/> Dates - 2nd to 4th June 2025 <br/> Venue - Gaylord Rockies Resort & Convention Center, Denver, Co.
                  </p>
                  <div class="button three past-event mr-300">
                <a href="/gartner-marketing-symposium-xpo-2025">Know More</a>
              </div>
                </div>
              </div>
            </div>
          </div>
       
         
      
         
        </div>
      </div>
    </div>
    </div>
  )
}
